var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wifi",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 70,
    viewBox: "0 0 104.772 74.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1211",
    "data-name": "Caminho 1211",
    d: "M104.212,29.324a73.374,73.374,0,0,0-103.653,0,1.908,1.908,0,1,0,2.7,2.7,69.558,69.558,0,0,1,98.257,0,1.907,1.907,0,0,0,2.7-2.7Z",
    transform: "translate(0 -7.89)",
    fill: "#cb8f55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1212",
    "data-name": "Caminho 1212",
    d: "M6.437,32.993a1.908,1.908,0,1,0,2.7,2.7,53.674,53.674,0,0,1,75.823,0,1.908,1.908,0,0,0,2.7-2.7A57.5,57.5,0,0,0,6.437,32.993Z",
    transform: "translate(5.338 -0.345)",
    fill: "#cb8f55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1213",
    "data-name": "Caminho 1213",
    d: "M41.709,24.508A41.292,41.292,0,0,0,12.316,36.665a1.908,1.908,0,0,0,2.7,2.7,37.8,37.8,0,0,1,53.389,0,1.908,1.908,0,0,0,2.7-2.7A41.288,41.288,0,0,0,41.709,24.508Z",
    transform: "translate(10.677 7.201)",
    fill: "#cb8f55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1214",
    "data-name": "Caminho 1214",
    d: "M33.4,33.916a12.5,12.5,0,1,0,12.5,12.5A12.515,12.515,0,0,0,33.4,33.916Zm0,21.186a8.686,8.686,0,1,1,8.686-8.686A8.694,8.694,0,0,1,33.4,55.1Z",
    transform: "translate(18.983 15.745)",
    fill: "#cb8f55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.4fbae7f804851d113b5215306f8fe1e5.svg";
export { ForwardRef as ReactComponent };